<template>
  <page :name="$t('La mia azienda')">
    <template #header>
      {{ $t('Presenta la tua attività, i prodotti e servizi che fornisce per poter conoscerci e collaborare meglio') }}
    </template>
    <pf-page-section>
      <introduction-form />
    </pf-page-section>
  </page>
</template>

<script lang="ts" setup>
import IntroductionForm from '../components/introduction-form.vue';
</script>
